import { FC, useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { Typography } from '@mui/material';
import { CenteredCardView, CenteredLoader, Link } from '@vs-online-only-app/ui';
import CreateAccountViewBody from './CreateAccountViewBody';
import { CreateAccountProvider } from './CreateAccountContext';
import { AuthenticationContext } from '@vs-online-only-app/state';

const CreateAccountView: FC = () => {
  const { isAuthenticated, verifyAuthenticatedState } = useContext(
    AuthenticationContext,
  );

  if (isAuthenticated) {
     return <Navigate to="/" replace />;
  }

  if (
    ['idle', 'loading'].includes(verifyAuthenticatedState) ||
    isAuthenticated
  ) {
    return <CenteredLoader />;
  }

  const footer = (
    <Typography variant="body1" color="textSecondary">
      Already have an account? <Link to="/login">Sign in</Link>
    </Typography>
  );

  const body = (
    <CreateAccountProvider>
      <CreateAccountViewBody />
    </CreateAccountProvider>
  );

  return <CenteredCardView body={body} footer={footer} />;
};

export default CreateAccountView;
